import './styles.scss'

const CLASS_NAME = 'loading-animation'

export const LoadingAnimation = () => {
  return (
    <div className={`${CLASS_NAME}`}>
      <img className={`${CLASS_NAME}__animation`} src="/loading-anim.gif" alt={'Loading'} />
    </div>
  )
}
